import { forwardRef } from "react";
import { Link, NavLink, type LinkProps, type NavLinkProps } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { buildLocalizedPath } from "../lib/localizedPath";

export const LocalizedLink = forwardRef<HTMLAnchorElement, LinkProps>(function LocalizedLink(
  { to, ...props },
  ref
) {
  const { lang } = useLanguage();
  return <Link {...props} to={buildLocalizedPath(to, lang)} ref={ref} />;
});

export const LocalizedNavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(function LocalizedNavLink(
  { to, ...props },
  ref
) {
  const { lang } = useLanguage();
  return <NavLink {...props} to={buildLocalizedPath(to, lang)} ref={ref} />;
});
